import React from 'react';
import { orderingMap, UNORDERED, orderIconMap, NONE, ariaSortMap } from './orderingMaps.js';
import { TableCol, TableHead, OrderButton } from './styles.js';

const TableHeadChildren = ({ children, order, onClick, }) => (React.createElement(React.Fragment, null, order ? (React.createElement(OrderButton, { order: order, onClick: onClick }, children)) : (children)));
const Column = ({ tableColumns, onSort }) => {
    const handleSort = (clickedColumn, currentOrder) => () => {
        if (!onSort) {
            return;
        }
        const newOrder = orderingMap[currentOrder || UNORDERED];
        return onSort(clickedColumn, newOrder);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("colgroup", null, tableColumns.map(({ key, width }) => (React.createElement(TableCol, { key: key, width: width })))),
        React.createElement("thead", null,
            React.createElement("tr", null, tableColumns.map(({ key, name, order, textAlign }) => {
                const OrderIcon = orderIconMap[order || NONE];
                const ariaSort = ariaSortMap[order || UNORDERED];
                return (React.createElement(TableHead, { key: key, scope: "col", order: order, "aria-sort": order && ariaSort, textAlign: textAlign },
                    React.createElement(TableHeadChildren, { order: order, onClick: handleSort({ key, name }, order) },
                        React.createElement(OrderIcon, { viewBox: "0 0 24 24" }),
                        name)));
            })))));
};

export { Column as default };
